export const TYPE_TECH = "tech";
